import { css } from "styled-system/css";

export const bannerCardStyles = css({
  display: "flex",
  flexDirection: "column",
  h: "full",
  p: { base: "16", desktop: "24" },
});

export const bannerLabelStyles = css({
  textStyle: "highlight.sm",
  letterSpacing: "[1px]",
  color: "text.tertiary",
});

export const bannerAmountStyles = css({
  mt: "16",
  textStyle: "subheading.xl",
  fontWeight: "light",
  color: "text.primary",
});
